import React from 'react';
import PropTypes from 'prop-types';
import ListeDeroulante from '../../UI/ListeDeroulante/ListeDeroulante';
import ArgumentInput from './ArgumentInput';
import MessageErreur from '../../UI/MessageErreur/MessageErreur';
import S from '../ProfilTasks/FormulaireTasks/FormulaireTasks.module.scss';

/**
 * Section de sélection et configuration de la fonction avec ses arguments
 *
 * erreur et erreursArguments sont des clés de traduction issues du schéma de
 * tâche ; erreursArguments est indexé comme fonction.arguments.
 */
const TaskFunctionSection = ({
  fonction,
  availableFunctions,
  loadingFunctions,
  erreur,
  erreursArguments,
  projectId,
  onFunctionChange,
  onArgumentChange,
  readOnly = false,
}) => {
  return (
    <div className={S.section}>
      <h4 className={S.sousTitre}>Fonction de la tâche</h4>

      <MessageErreur cle={erreur} />

      <div className={S.argumentBasicInfo}>
        <div className={S.champGroupe}>
          <label className={S.label}>Sélectionner une fonction *</label>
          <ListeDeroulante
            value={fonction?.function_id || ''}
            onChange={(v) => onFunctionChange('function_id', v)}
            options={availableFunctions}
            disabled={loadingFunctions || readOnly}
          />
        </div>
        {fonction?.loading && (
          <div className={S.champGroupe}>
            <p>Chargement des arguments...</p>
          </div>
        )}
      </div>

      {fonction?.function_id && (
        <>
          <div className={S.argumentsHeader}>
            <h5 className={S.sousTitre}>Arguments</h5>
          </div>

          {!fonction.function_id ? (
            <div className={S.aucunArgument}>
              <p>Sélectionnez une fonction pour charger ses arguments.</p>
            </div>
          ) : (fonction.arguments || []).length === 0 ? (
            <div className={S.aucunArgument}>
              <p>Cette fonction n'a pas d'arguments configurés.</p>
            </div>
          ) : (
            <div className={S.argumentsList}>
              {(fonction.arguments || []).map((argument, ai) => (
                <div key={argument.id} className={S.argumentItem}>
                  <div className={S.argumentContent}>
                    {argument.description && (
                      <div className={S.champGroupe}>
                        <p className={S.argumentDescription}>
                          {argument.description}
                        </p>
                      </div>
                    )}

                    <div className={S.champGroupe}>
                      <label className={S.label}>
                        {argument.nom}
                        {argument.obligatoire && ' *'}
                      </label>

                      <ArgumentInput
                        argument={argument}
                        index={ai}
                        onChange={onArgumentChange}
                        projectId={projectId}
                        readOnly={readOnly}
                      />
                      <MessageErreur cle={erreursArguments?.[ai]} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

TaskFunctionSection.propTypes = {
  fonction: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    function_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nom: PropTypes.string,
    loading: PropTypes.bool,
    arguments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nom: PropTypes.string,
        type: PropTypes.string,
        obligatoire: PropTypes.bool,
        description: PropTypes.string,
      })
    ),
  }),
  availableFunctions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ).isRequired,
  loadingFunctions: PropTypes.bool.isRequired,
  erreur: PropTypes.string,
  erreursArguments: PropTypes.arrayOf(PropTypes.string),
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFunctionChange: PropTypes.func.isRequired,
  onArgumentChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

TaskFunctionSection.defaultProps = {
  fonction: null,
  erreur: null,
  erreursArguments: [],
  projectId: null,
  readOnly: false,
};

export default React.memo(TaskFunctionSection);
